import queryStringParser from "query-string";
import dayjs from "dayjs";
import { History } from "history";
import { getIsTravelApp } from "@capone/common";
import { PremierCollectionShopStep } from "../../shop/reducer";

export interface IPremierCollectionAvailabilityParsedQuery {
  locationName: string;
  fromDate: Date;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number;
  isTravelApp?: boolean;
  shopStep?: PremierCollectionShopStep;
  bookStep?: number;
  showMap?: boolean;
}

export const parseQueryFromString = (
  queryString: string
): IPremierCollectionAvailabilityParsedQuery => {
  const {
    locationName,
    fromDate,
    untilDate,
    adultsCount,
    childrenCount,
    shopStep,
    bookStep,
    showMap,
  } = queryStringParser.parse(queryString);
  const { isTravelApp } = getIsTravelApp(queryString);

  return {
    locationName: locationName as string,
    fromDate: dayjs(fromDate as string).toDate(),
    untilDate: untilDate ? dayjs(untilDate as string).toDate() : null,
    adultsCount: parseInt(adultsCount as string),
    childrenCount: parseInt(childrenCount as string),
    isTravelApp,
    shopStep: shopStep
      ? (parseInt(shopStep as string) as PremierCollectionShopStep)
      : undefined,
    bookStep: bookStep ? parseInt(bookStep as string) : undefined,
    showMap: showMap === undefined ? undefined : showMap === "true",
  };
};

export const parseQueryString = (
  history: History
): IPremierCollectionAvailabilityParsedQuery | null => {
  const queryString = history?.location?.search || "";
  return queryString ? parseQueryFromString(queryString) : null;
};
